import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialsProps {
  language: 'en' | 'es';
}
export function Testimonials({
  language
}: TestimonialsProps) {
  const t = {
    en: {
      testimonials: [{
        quote: 'Great communication, very clean units. Delivered exactly when they said they would to our construction site. Will use Blackstone again on every project.',
        author: 'R. Thompson',
        role: 'Site Supervisor',
        location: 'Odessa, TX'
      }, {
        quote: 'We rented a porta-potty and trash trailer combo for our event and had zero issues. Seamless process, on-time delivery, and they accommodated every request. Highly recommend.',
        author: 'J. Martinez',
        role: 'Event Organizer',
        location: 'Midland, TX'
      }, {
        quote: 'Needed a dump trailer for a weekend ranch cleanup. Equipment was in great condition, pricing was fair, and they made the whole thing easy. Best rental company in West Texas.',
        author: 'D. Alvarez',
        role: 'Ranch Owner',
        location: 'Andrews, TX'
      }]
    },
    es: {
      testimonials: [{
        quote: 'Excelente comunicación, unidades muy limpias. Entregaron exactamente cuando dijeron que lo harían en nuestro sitio de construcción. Usaremos Blackstone de nuevo en cada proyecto.',
        author: 'R. Thompson',
        role: 'Supervisor de Obra',
        location: 'Odessa, TX'
      }, {
        quote: 'Rentamos un baño portátil y remolque de basura combo para nuestro evento y no tuvimos ningún problema. Proceso sin complicaciones, entrega a tiempo y acomodaron cada solicitud. Muy recomendado.',
        author: 'J. Martinez',
        role: 'Organizador de Eventos',
        location: 'Midland, TX'
      }, {
        quote: 'Necesitaba un dump trailer para limpieza de rancho de fin de semana. El equipo estaba en excelentes condiciones, el precio fue justo y lo hicieron todo fácil. La mejor empresa de rentas en West Texas.',
        author: 'D. Alvarez',
        role: 'Dueño de Rancho',
        location: 'Andrews, TX'
      }]
    }
  };
  const text = t[language];
  const avatars = ['https://cdn.magicpatterns.com/uploads/fZacEFKUtSCvveUBXioH1i/R._Thompson.png', 'https://cdn.magicpatterns.com/uploads/vmdGD136PfMvZV5PSRnDSG/J._Martinez.png', 'https://cdn.magicpatterns.com/uploads/kco63GydatkoFP8ge734PS/D._Alvarez.png'];
  return <section className="py-10 md:py-16 bg-carbon border-y border-steel w-full overflow-hidden" data-id="element-372">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-373">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8" data-id="element-374">
          {text.testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-obsidian p-8 rounded-lg border border-steel relative text-center flex flex-col" data-id="element-375">
              {/* Avatar */}
              <div className="flex justify-center mb-5" data-id="element-376">
                <div className="w-20 h-20 rounded-full ring-[3px] ring-gold ring-offset-2 ring-offset-obsidian overflow-hidden" data-id="element-377">
                  <img src={avatars[index]} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-378" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex justify-center gap-1 mb-5" data-id="element-379">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="#C9952A" color="#C9952A" data-id="element-380" />)}
              </div>

              {/* Quote */}
              <p className="font-inter text-gray-300 italic mb-8 leading-relaxed flex-grow" data-id="element-381">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="mt-auto" data-id="element-382">
                <p className="font-montserrat font-bold text-warmWhite text-sm" data-id="element-383">
                  — {testimonial.author}
                </p>
                <p className="font-inter text-gold text-sm mt-1" data-id="element-384">
                  {testimonial.role} | {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}